import toast from 'react-hot-toast';

const guard = () => typeof window !== 'undefined' && window.__suppressToasts;

const guarded = {
  success: (message, options) => { if (guard()) return; return toast.success(message, options); },
  error: (message, options) => { if (guard()) return; return toast.error(message, options); },
  loading: (message, options) => { if (guard()) return; return toast.loading(message, options); },
  dismiss: (...args) => toast.dismiss(...args),
  // expose original in case needed
  __raw: toast
};

export default guarded;


